import { useEffect } from "react";

type EnterKeyOptions = {
  onEnter: () => void;
  skipTags?: string[]; // optional: tags where Enter should be ignored
};

export const useEnterKeyAction = ({
  onEnter,
  skipTags = ["LI", "SELECT"],
}: EnterKeyOptions) => {
  useEffect(() => {
    const handleEnter = (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        const active = document.activeElement as HTMLElement | null;

        if (active && skipTags.includes(active.tagName)) {
          return; // Ignore if focused on specified tags
        }

        e.preventDefault();
        onEnter();
      }
    };

    window.addEventListener("keydown", handleEnter);
    return () => window.removeEventListener("keydown", handleEnter);
  }, [onEnter, skipTags]);
};
